import React from "react";
import { useAdminAuth } from "../admin/auth";
import AdminLogin from "../admin/AdminLogin";
import AdminDashboard from "../admin/AdminDashboard";

export default function AdminPage() {
  const { authed } = useAdminAuth();
  return authed ? <AdminDashboard /> : <AdminLogin />;
}
